import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Coduri promoționale',
  tabs: {
    active: 'Active',
    expired: 'Expirate',
    email_sign_up: 'Înregistrare email cu promo',
  },
  show_master_promo_code: 'Afișează codul promoțional master clienților',
  send_rejected_order_apologies_promo_code: 'Trimite cod promoțional clienților când comanda este respinsă manual',
  filters: {
    tag: {
      placeholder: 'Etichetă',
      options: {
        [PromoCodeTag.Master]: 'Master',
        [PromoCodeTag.Campaign]: 'Campanie',
        [PromoCodeTag.OneTime]: 'O singură dată',
      },
    },
    code: {
      placeholder: 'Cod',
    },
    campaign: {
      placeholder: 'Campanie',
    },
    created_by: {
      placeholder: 'Creat de',
      options: {
        [PromoCodeCreatedBy.User]: 'Utilizator',
        [PromoCodeCreatedBy.System]: 'Sistem',
      },
    },
  },
  fields: {
    code: 'Cod',
    tag: 'Etichetă',
    type: 'Tip',
    discount_type: 'Tip reducere',
    discount: 'Reducere',
    usage_threshold: 'Prag utilizare',
    quantity: 'Cantitate',
    expires_at: 'Expiră',
    level: 'Nivel',
    max_discount: 'Reducere maximă',
    created_by: 'Creat de',
    image: 'Imagine',
  },
  tags: {
    [PromoCodeTag.Master]: 'Master',
    [PromoCodeTag.Campaign]: 'Campanie',
    [PromoCodeTag.OneTime]: 'O singură dată',
  },
  types: {
    single_use: 'Utilizare unică',
    multi_use: 'Utilizare multiplă',
    unknown: 'Necunoscut',
  },
  discount_types: {
    fixed_amount: 'Sumă fixă',
    percentage: 'Procent',
    unknown: 'Necunoscut',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Utilizator',
    [PromoCodeCreatedBy.System]: 'Sistem',
  },
  labels: {
    discount: 'Reducere',
    usage_threshold: 'Prag utilizare',
    company: 'Companie',
    restaurant: 'Restaurant',
    restaurant_group: 'Brand',
  },
  buttons: {
    add: 'Adaugă',
    edit: 'Editează',
    delete: 'Șterge',
    restore: 'Restaurează',
    add_promo_code: 'Adaugă cod promoțional',
    images: 'Gestionare imagine',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    failed_to_save_settings: 'Salvarea modificărilor a eșuat',
    failed_to_delete_promo_code: 'Ștergerea codului promoțional a eșuat',
    failed_to_restore_promo_code: 'Restaurarea codului promoțional a eșuat',
    promo_code_got_deleted: 'Codul promoțional a fost șters',
    promo_code_got_restored: 'Codul promoțional a fost restaurat',
  },
  delete_confirmation: {
    title: 'Ștergeți codul promoțional?',
    buttons: {
      yes: 'Da',
      no: 'Nu',
    },
  },
  restore_confirmation: {
    title: 'Restaurați codul promoțional?',
    buttons: {
      yes: 'Da',
      no: 'Nu',
    },
  },
};
